module.exports = __webpack_public_path__ + "static/img/PROTE PU products discription1_deskstop.45b0ea7c.jpg";